/**
 * Settings-page Alpine component for the web push toggle.
 *
 * State is derived from the browser (Notification.permission) and local
 * registration cache. The component never auto-prompts: requestPermission
 * only fires when the user clicks the toggle.
 */
import { requestEnable, disablePush, getRegistrationStatus } from './web-push.js';

export function webPushSettings(strings = {}) {
    const messages = {
        registerFailed: strings.registerFailed
            || "Couldn't enable push notifications. Refresh the page and try again.",
    };

    return {
        supported: false,
        enabled: false,
        working: false,
        permissionDenied: false,
        errorMessage: '',

        init() {
            const status = getRegistrationStatus();
            this.supported = status.supported;
            this.enabled = status.enabled;
            this.permissionDenied = status.permission === 'denied';
        },

        async toggle() {
            if (this.working || !this.supported) {
                return;
            }
            this.working = true;
            this.errorMessage = '';
            try {
                if (this.enabled) {
                    await disablePush();
                    this.enabled = false;
                    return;
                }
                const result = await requestEnable();
                // Re-read status from the source of truth (Notification.permission
                // + local registration cache) rather than trusting the permission
                // result alone. If permission was granted but the FCM/server-side
                // registration failed, the cache stays empty and the toggle must
                // reflect that as still-off.
                const status = getRegistrationStatus();
                this.enabled = status.enabled;
                this.permissionDenied = status.permission === 'denied' || result === 'denied';
                if (result === 'registration-failed') {
                    this.errorMessage = messages.registerFailed;
                }
            } finally {
                this.working = false;
            }
        },
    };
}
